import React, { useState, useCallback } from 'react';
import { BlockStack, InlineStack, Text, FormLayout, InlineGrid, TextField, Popover, Button, Divider } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import Placeholder from '../common/Placeholder';

const ViewRateField = ({ rates, date }) => {
    const { store_data } = useSelector((store) => store.commonData);
    const [popoverActive, setPopoverActive] = useState(false);

    const currency = store_data?.shop_data?.currency || 'USD';

    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );

    const activator = (
        <Button onClick={(e) => {
            e.stopPropagation();
            togglePopoverActive();
        }} variant='plain'>
            View Rates
        </Button>
    );

    return (
        <Popover
            active={popoverActive}
            activator={activator}
            onClose={togglePopoverActive}
            ariaHaspopup={false}
            sectioned
        >
            <BlockStack gap="100">
                <InlineStack align='space-between' blockAlign='center'>
                    <Text variant="headingSm" as="p">
                        Gold Rates as of{' '}
                        <Text variant="bodyMd" as="p">
                            {date}
                        </Text>
                    </Text>
                </InlineStack>
            </BlockStack>
            <Placeholder padding='5px var(--p-space-200)' />
            <Divider />
            <Placeholder padding='5px var(--p-space-200)' />
            <FormLayout.Group>
                <InlineGrid gap="200" columns={2}>
                    {Object.keys(rates).map((key) => (
                        <TextField
                            key={key}
                            label={`Gold Price ${key} / Gram`}
                            type="number"
                            min="0"
                            value={rates[key]}
                            name={key}
                            suffix={currency}
                            disabled
                        />
                    ))}
                </InlineGrid>
            </FormLayout.Group>
        </Popover>
    )
};

export default ViewRateField;
